// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".hrsata-jobs .chat-container[data-v-358abe7a]{max-height:500px;overflow-y:auto;scroll-behavior:smooth}", ""]);
// Exports
module.exports = exports;
